<audit-logs class="p-3"
            [auditLogs]="audit$ | async"
            [loading]="loading$ | async"
            [resourceType]="resourceType"
            [configuration]="configuration">
</audit-logs>
